export default __webpack_public_path__ + "locales/hy-AM/Article.json?hash=7c32d1edd960567547bfc6aaf4d5eba3";